import React, { useEffect, useState } from "react";

import logo from "../../../images/register-logo.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import Cookies from "cookie-universal";

import Logo from "../../../components/Logo/Logo";
import { toast } from "react-toastify";
import Notifcation from "../../../components/Notification";
import Loading from "../../../components/Loading/Loading";
import { useTranslation } from "react-i18next";
const Provider = () => {
  const cookie = Cookies();
  const [laoding, setLaoding] = useState(false);

  const nav = useNavigate();
  const { t, i18n } = useTranslation();



  const { provider, token } = useParams();

  const handelSubmit = async (e) => {
    setLaoding(true);
    setTimeout(() => {
      setLaoding(false);
      toast.success(t('Welcome To Goba'));
      setTimeout(() => {
        cookie.set("token", token);
        window.location.pathname = "/student";
      }, 1000);
    }, 2000);
  
  };
  return (
    <>
      {laoding && <Loading />}
      <Notifcation />
      <div className="Login">
        <div className="main">
          <div className="logo ">
            <Logo />
          </div>
          <form className="form-box">
            <h2>{t("Account")}</h2>
            <p className="text-center">
              {t("Welcome To Goba Store , your trying to sign in using your { provider } account , do u want to continue?")}
            </p>
            <div className="inputs"></div>
            <button type="button" onClick={handelSubmit}>
              {t("Continue")}
            </button>
          </form>

          <div className="content">
            <img src={logo} alt="juba" loading="lazy" />
            <h2>
              {t("Welcome to")} <br className="hidden md:block" />
              {t("Juba academy")}
            </h2>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur. Condimentum aliquam
              sagittis senectus purus fames.{" "}
            </p> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Provider;
